import React from "react";
import styled from "styled-components";
import { Item, ItemText } from "@radix-ui/react-select";
const StyledOption = ({ children, ...props }) => (React.createElement(Item, { ...props },
    React.createElement(ItemText, null, children)));
StyledOption.defaultProps = {
    "data-testid": "select-option",
};
export const Option = styled(StyledOption) ``;
//# sourceMappingURL=Option.js.map